import React, { useEffect, useState } from 'react';
import { RiMailCheckLine, RiInboxArchiveLine, RiSendPlaneLine, RiMailCloseLine } from "react-icons/ri";
import { useDispatch, useSelector } from 'react-redux';
import { emailSliceAction } from '../../store/emailSlice';
import EmailSender from '../../config/emailSender.json';
import { getInboxMailList } from '../../utils/awsAPI';


const MailMenu = () => {
    const dispatch = useDispatch()
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const selectedMenu = useSelector((state:any)=>{return state.emailSlice.selectedMenu})
    const lastEvaluatedKey = useSelector((state:any)=>{return state.emailSlice.LastEvaluatedKey})
    const [inboxDomain, setInboxDomain] = useState<any>("")
    const [outboxDomain, setOutboxDomain] = useState<any>("")
    const [failedboxDomain, setFailedboxDomain] = useState<any>("")
    const [assignEmails, setAssignEmails] = useState<any>("")
    const [deliveryFailedEmail, setDeliveryFailedEmail] = useState<any>("")
    useEffect(()=>{
        if(agentObj) {
            let routingProfile = agentObj.getRoutingProfile().name
            let groupEmails = EmailSender?.filter((item:any) => item.routingProfileName === routingProfile)[0]?.assignEmailIds;
            setAssignEmails(groupEmails)
            let failedEmail = EmailSender?.filter((item:any) => item.routingProfileName === routingProfile)[0]?.senderEmailIds;
            setDeliveryFailedEmail(failedEmail)
        }
    },[agentObj])
    
    const onMenuChange = (menuName:any) => {
        dispatch(emailSliceAction.setSelectedMenu(menuName))
        dispatch(emailSliceAction.setEmailDetails(""))
        dispatch(emailSliceAction.setSelectedContact(""))
        dispatch(emailSliceAction.setInboxList([]))
        dispatch(emailSliceAction.setOutboxList([]))
        dispatch(emailSliceAction.setFailedEmailList([]))
        setInboxDomain("")
        setOutboxDomain("")
        setFailedboxDomain("")
    }

    const getEmailList = async(workmailDomain:any, emailType:any) => {
        dispatch(emailSliceAction.setEmailLoading(true))
        let data = await getInboxMailList(workmailDomain, emailType, lastEvaluatedKey)
        if(data.success){
            if(emailType === 'inbox') {
                dispatch(emailSliceAction.setInboxList(data?.data?.body?.Items))
                setInboxDomain(workmailDomain)
            } else if(emailType === 'sent') {
                dispatch(emailSliceAction.setOutboxList(data?.data?.body?.Items))
                setOutboxDomain(workmailDomain)
            } else if (emailType === 'failed') {
                dispatch(emailSliceAction.setFailedEmailList(data?.data?.body?.Items))
                setFailedboxDomain(workmailDomain)
            }
            dispatch(emailSliceAction.setWorkmailDomain(workmailDomain))
            dispatch(emailSliceAction.setLastEvaluatedKey(data?.data?.body?.LastEvaluatedKey))
        } else {
            dispatch(emailSliceAction.setLastEvaluatedKey(""))
        }
        dispatch(emailSliceAction.setEmailLoading(false))
    }


    return (
        
            <div className="card wrapup-box collapse show mt-3" id="ChatWrapup">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Mailbox</h6>
                </div>
                <div className="card-body height-400">
   
                <ul id="accordion" className='mailbox-list list-unstyled'>
                        <li><button onClick={()=>{onMenuChange('active')}} className={`${(selectedMenu === 'active') ? `active-mailbox` : ``}`} data-bs-toggle="collapse" data-bs-target="#collapseOne"><RiMailCheckLine /> Active </button></li>
                        <li><button onClick={()=>{onMenuChange('inbox')}} className={`${(selectedMenu === 'inbox') ? `active-mailbox` : ``} dropdown-toggel`} data-bs-toggle="collapse" data-bs-target="#collapseTwo"><RiInboxArchiveLine /> Inbox </button>
                        <div id='collapseTwo' className='collapse mail-group' data-bs-parent="#accordion">
                            {assignEmails && assignEmails.map((item:any, index:any) => {
                                return <div className={`mail-group-item ${(inboxDomain === item) ? `active-submailbox` : ``}`} key={index} onClick={()=>{getEmailList(item, 'inbox')}}>{item}</div>
                            })}
                        </div>
                        </li>
                        <li><button onClick={()=>{onMenuChange('sent')}} className={`${(selectedMenu === 'sent') ? `active-mailbox` : ``} dropdown-toggel`} data-bs-toggle="collapse" data-bs-target="#collapseThree"><RiSendPlaneLine /> Sent </button></li>
                        <div id='collapseThree' className='collapse mail-group' data-bs-parent="#accordion">
                            {assignEmails && assignEmails.map((item:any, index:any) => {
                                return <div className={`mail-group-item ${(outboxDomain === item) ? `active-submailbox` : ``}`} key={index} onClick={()=>{getEmailList(item, 'sent')}}>{item}</div>
                            })}
                        </div>
                        <li><button onClick={()=>{onMenuChange('failed')}} className={`${(selectedMenu === 'failed') ? `active-mailbox` : ``} dropdown-toggel`} data-bs-toggle="collapse" data-bs-target="#collapseFour"><RiMailCloseLine /> Delivery failed </button></li>
                        <div id='collapseFour' className='collapse mail-group' data-bs-parent="#accordion">
                            {deliveryFailedEmail && deliveryFailedEmail.map((item:any, index:any) => {
                                return <div className={`mail-group-item ${(failedboxDomain === item) ? `active-submailbox` : ``}`} key={index} onClick={()=>{getEmailList(item, 'failed')}}>{item}</div>
                            })}
                        </div>
                    </ul>
                </div>
            </div>
     
    )
}
export default MailMenu;